// extracted by mini-css-extract-plugin
export default {"container":"style_container__73HIv","page":"style_page__TfPfj","error":"style_error__uTsjH"};